import { useQRPreloader } from "./useQRPreloader";

const QRPreloader = ({ account }) => {
  useQRPreloader(account);
  return null; // Component này không render gì
};

export default QRPreloader;
